import React ,  { Component } from 'react';
import firestore from '../fbconfig'
import Project from './Project';
import styled, {keyframes} from  'styled-components';
import background from '../images/alternativebackground.png'
import Navbar from './Navbar';
import { fadeIn } from 'react-animations';

const FadeInAnimation = keyframes`${fadeIn}`;

const Container = styled.div`
width:100%;
background: url(${background});
background-size:cover;                      /* <------ */
background-repeat:no-repeat;
margin: 0 auto;
animation: 0.8s ${FadeInAnimation};
color:#EAE1E1;
@media (max-height:880px) {
    width:100%;
    
}

@media (max-width:512px) {
    width:100%;
    height:100%;
}

@media (min-height:900px){
    width:100%;
    min-height:100vh;
}
`

const CardWrapper = styled.div`
width:100%;
display:grid;
grid-template-columns: repeat(2,auto);
padding-bottom:40px;
@media (max-width: 900px) {
    display:grid;
    grid-template-columns: repeat(1,auto);
    padding-bottom:20px;
    
}

`

class Portfolio extends Component {



    state = {
        projects: []
    }
    
    
    componentDidMount() {
        firestore.collection('Projects').get().then((snap) => {
            this.setState({projects: snap.docs})
        })  
    }
 

    render() { 
        
       

        return (
            <Container>
                <Navbar/>
                <CardWrapper>
                    {
                        this.state.projects.map((d)=> (
                            <div>
                                <Project titolo={d.data().titolo} descrizione={d.data().descrizione}  tecn={d.data().tecn} imglink={d.data().imglink}/>
                            </div>
                        ))
                    }
                </CardWrapper>
            </Container>
        )
    }
}
 
export default Portfolio;




